/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Vu Dinh Luan (vdluan@rsupport.com)
 *
 * @description
 *
 * @created at Fri Sep 13 2024
 **/

import { ModalID, SidebarID } from "@/frameworks/core/commons";
import { useSidebarActions } from "@/frameworks/core/hooks";
import { usePersistActions } from "@/frameworks/core/persistence";
import { Button, Row, Typography, Image, useModal, Column } from "@/frameworks/designStuff/components";
import { _T, _P } from "@rfice/language";
import { hoverScrollCss } from "@/frameworks/designStuff/utils";

import * as S from "./emotion";
import Group from "@/assets/images/backgrounds/img_make_group_type-1.png";
import CreateGroup from "@/assets/images/backgrounds/img_make_group_type-2.png";
import InstructCreateGroup from "./InstructCreateGroup";

const NewMemberNoGroup = () => {
	const { users } = usePersistActions();
	const sidebarActions = useSidebarActions();
	const { hide, show } = useModal();

	const handleShowListGroup = () => {
		hide(ModalID.USER_NO_GROUP);
		sidebarActions.show(SidebarID.Space);
		sidebarActions.show(SidebarID.FindGroupSpace);
	};

	const handleCreateGroup = () => {
		hide(ModalID.USER_NO_GROUP);
		show({
			id: ModalID.INSTRUCT_CREATE_GROUP,
			content: <InstructCreateGroup />
		});
	};

	const handleClose = () => {
		hide(ModalID.USER_NO_GROUP);
		sidebarActions.show(SidebarID.Space);
	};

	return (
		<S.ViewerWrap css={hoverScrollCss} horizonAlign="center">
			<Row css={{ width: "100%", marginRight: 24, marginTop: 60 }} horizonAlign="right">
				<Button.Icon name="Close24" size="XXXlarge" variant="text" onClick={handleClose} />
			</Row>
			<Column style={{ height: "800px", width: "100%", marginTop: "16px" }} horizonAlign="center" gap={24}>
				<Typography.h2
					css={{ whiteSpace: "pre-line", textAlign: "center", marginBottom: "40px" }}
					typoSize="Head5_B"
				>
					{_P("소속된 그룹이 없습니다. \n{{name}}님 알피스 탐험을 환영합니다!!", {
						name: `<span style="color: #7F86F3" >${users.me.name}</span>`
					})}
				</Typography.h2>
				<Row gap={20}>
					<S.BackgroundContent horizonAlign="center">
						<Column
							css={{ minHeight: "60px", width: "100%", marginTop: 39, marginBottom: 16 }}
							verticalAlign="bottom"
							horizonAlign="center"
						>
							<Typography.h2 typoColor="neutral_80_100" typoSize="Head6">
								{_T("탐색하고 싶은 그룹이 있으신가요?")}
							</Typography.h2>
						</Column>
						<Typography.h2 css={{ whiteSpace: "pre-line", textAlign: "center" }} typoSize="Body3_MD">
							{_T("'그룹 탐색' 버튼을 클릭한 뒤\n그룹을 탐색해보세요.")}
						</Typography.h2>
						<S.ImagesContent horizonAlign="center" verticalAlign="bottom">
							<Button
								css={{ borderRadius: 100, width: 160, height: 44 }}
								typoColor="neutral_00_100"
								typoSize="Button1"
								onClick={handleShowListGroup}
							>
								{_T("그룹 탐색")}
							</Button>
							<Image css={{ borderRadius: 40 }} src={Group} />
						</S.ImagesContent>
					</S.BackgroundContent>
					<S.BackgroundContent horizonAlign="center">
						<Column
							css={{ minHeight: "60px", width: "100%", marginTop: 39, marginBottom: 16 }}
							verticalAlign="bottom"
							horizonAlign="center"
						>
							<Typography.h2
								css={{
									whiteSpace: "pre-line",
									textAlign: "center",
									lineHeight: 1.5
								}}
								typoColor="neutral_80_100"
								typoSize="Head6"
							>
								{_T("새로운 사람들과, \n새로운 그룹을 만들고 싶으신가요?")}
							</Typography.h2>
						</Column>

						<Typography.h2 css={{ whiteSpace: "pre-line", textAlign: "center" }} typoSize="Body3_MD">
							{_T("‘그룹 생성’ 버튼을 클릭한 뒤, \n그룹을 직접 생성하세요.")}
						</Typography.h2>
						<S.ImagesContent horizonAlign="center" verticalAlign="bottom">
							<Button
								css={{ borderRadius: 100, width: 160, height: 44 }}
								typoColor="neutral_00_100"
								onClick={handleCreateGroup}
								typoSize="Button1"
							>
								{_T("그룹 생성")}
							</Button>
							<Image css={{ borderRadius: 40 }} src={CreateGroup} />
						</S.ImagesContent>
					</S.BackgroundContent>
				</Row>
			</Column>
		</S.ViewerWrap>
	);
};

export default NewMemberNoGroup;
